import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = Omit<ComponentProps<"svg">, "strokeWidth"> & {
	active?: boolean
	// Same scale as the Nucleo 18px icons; the 22-unit viewBox is converted below.
	strokeWidth?: number | string
}

export const AiAssistantIcon = forwardRef<SVGSVGElement, Props>(
	({ active = false, strokeWidth = 1.5, ...props }, ref) => {
		const width = (Number(strokeWidth) * 22) / 18
		return (
			<svg
				width={18}
				height={18}
				viewBox="0 0 22 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				aria-hidden="true"
				ref={ref}
				{...props}
			>
				<defs>
					<linearGradient
						id="ai-assistant-gradient"
						x1="-1.95954"
						y1="-3.5044"
						x2="8.97505"
						y2="8.17725"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#6EC499" />
						<stop offset="0.5" stopColor="#32A3DB" />
						<stop offset="1" stopColor="#6EC499" />
					</linearGradient>
				</defs>
				<path
					d="M12.58 4.14A3.78 3.78 0 0 1 17.37 9.97L11.75 15.59C10.71 16.62 9.34 17.19 7.88 17.19H4.81M5.62 11.08C4.88 12.03 4.47 13.2 4.46 14.43V17.54M11.89 10.11L3.5 18.5"
					stroke={active ? "#6EC499" : "currentColor"}
					strokeWidth={width}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4.6064 5.3278C5.74433 4.9898 6.65673 4.13574 7.06909 3.0226L7.27713 2.46094L7.44766 3.03511C7.78566 4.17304 8.63971 5.08544 9.75285 5.49779L10.3145 5.70584L9.74034 5.87637C8.60242 6.21436 7.69001 7.06842 7.27766 8.18156L7.06961 8.74322L6.89909 8.16905C6.56109 7.03113 5.70704 6.11872 4.59389 5.70637L4.03223 5.49832L4.6064 5.3278Z"
					stroke={active ? "url(#ai-assistant-gradient)" : "currentColor"}
					strokeWidth={width}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		)
	},
)
